import { render, staticRenderFns } from "./periodicals.vue?vue&type=template&id=173259de&scoped=true&"
import script from "./periodicals.vue?vue&type=script&lang=js&"
export * from "./periodicals.vue?vue&type=script&lang=js&"
import style0 from "./periodicals.vue?vue&type=style&index=0&id=173259de&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "173259de",
  null
  
)

export default component.exports